export default class ActionHelper {
  static get SET_ANY_PARAMS_STORE() {
    return 'common/SET_ANY_PARAMS_STORE'
  }

  static setAnyParamsStore = (state, action) => {
    for (const param in action.payload) {
      if (action.payload.hasOwnProperty(param)) {
        // eslint-disable-next-line no-param-reassign
        state = state.set(param, action.payload[param])
      }
    }

    return state
  }

  static createActionObj = type => (payload, promise = {}) => ({
    type,
    payload,
    promise,
  })
}
